module.exports = __webpack_public_path__ + "static/media/012.8a35f468.png";